const en = {
	title: 'payment link',
	create: 'Add',
	paymentLinkId: 'Payment link ID',
	paymentLink_Id: 'Payment link-ID',
	bookingName: 'Booker name',
	bookingNameEmail: 'Booker name/email',
	orderNo: 'Transaction ID',
	amount: 'Amount',
	tradingamount: 'Transaction amount',
	minAmount: 'Min',
	maxAmount: 'Max',
	createTime: 'Created time',
	paymentLinkStatus: 'Payment link status',
	status: 'Payment status',
	operate: 'Operate',
	search: 'Search',
	reset: 'Reset',
	add: 'Add',
	edit: 'Edit',
	delete: 'Delete',
	export: 'Export',
	detail: 'Detail',
	resend: 'Resend',
	disable: 'Disable',
	tipsTitle: 'Tips',
	invalidTip: 'The payment link has been set to an invalid state',
	setInvalid: 'Confirm set this payment link disabled? The lapsed payment chain will not be reinstated.',
	sendSuccess: 'Send successfully',
	deleteSuccess: 'Delete successfully',
	notTepmTitle: 'You have not created a billing template yet.',
	notTepmTip: 'Please create a billing template in the "Template Management" feature before creating a payment link.',
	toNewVersion: 'Go to new page.',
	toOldVersion: 'Go to old page.',
	createLink: {
		title: 'Create my payment link',
		otherFee: 'Are there any other fees?',
		yes: 'Yes',
		no: 'No',
		otherFeeName: 'Name of other fees',
		createSuccess: 'Payment link created successfully!',
		tip: "The payment chain link will be generated separately if the payer's email is not filled in during the creation of the information.",
		createTemplate: 'Go to create template'
	},
	brandList: {
		title: 'brand information maintenance',
		brandName: 'Brand Name',
		website: 'Website',
		updateTime: 'Update Time',
		add: 'Add new brand',
		logo: 'Logo',
		preview: 'Preview',
		brandWeb: 'Brand website',
		contact: 'Contact',
		validTime: 'Payment link valid time',
		email: 'Email notification template',
		edit: 'Edit',
		delete: 'Delete',
		deleteTip: 'Please confirm to delete this brand information.',
		message: {
			addSuccess: 'Brand added successfully!',
			editSuccess: 'Brand information updated successfully!'
		}

	},
	paymentLinkDetail: {
		setInvalid: 'Set to invalid',
		resend: 'Resend',
		validTime: 'Valid Time',
		hours: 'Hours',
		remaining: 'Remaining',
		linkAddress: 'Payment link link address',
		userInfo: 'User Information',
		name: 'Booker name ',
		phone: 'Mobile phone number',
		email: 'E-mail',
		en: 'English',
		lang: 'checkout language',
		country: 'Country/Region',
		remarks: 'notes',
		orderInfo: 'Billing Information',
		productInfo: 'Product Information',
		editProductInfo: 'Edit product information',
		affiliatedWebsite: 'Affiliated Website',
		currency: 'Currency',
		serviceDate: 'Service Date',
		city: 'City',
		total: 'Total',
		totalAmount: 'Total amount',
		brandInfo: 'Brand Information',
		brandName: 'Brand Name',
		addProduct: 'Add',
		addProductTip: 'Please ',
		createPayLinkValidate: 'Unable to create a payment link without adding product information',
		previewPayLinkValidate: 'Unable to preview without adding product information',
		cancelTip: 'The basic information is not completed yet. Unable to generate a payment link. Are you sure you want to cancel?',
		// 支付链标准化
		template: 'Bill Template',
		website: 'Associated Website',
		prodName: 'Product Name',
		prodDesc: 'Product Description',
		PassengerName: 'Passenger Name',
		hotelName: 'Hotel Name',
		days: 'Number of nights',
		roomsNumber: 'Number of rooms',
		price: 'Unit Price',
		count: 'Quantity',
		amount: 'Amount',
		rentType: 'Rent Type',
		address: 'Address',
		apartmentNumber: 'Apartment Number',
		rentTime: 'Rental Time',
		carModel: 'Rented Car Model',
		destinationAddress: 'Destination Address',
		mileage: 'Mileage',
		carRentalUnitPrice: 'CarRental  Unit Price',
		carRentCountry: 'Rent City',
		carTime: 'Service Date',
		travelCity: 'Travel City',
		takeOffCity: 'Take off City',
		travelCountry: 'Travel Country',
		travelTime: 'Travel Time',
		flightNumber: 'Flight Number',
		aircraftCabinType: 'Route Type',
		takeOffTime: 'Take off Time',
		arrivalTime: 'Arrival Time',
		reChargeType: 'ReCharge Type',
		accountId: 'Account Id',
		accountName: 'Account Name',
		appName: 'Game/APP Name',
		time: '{hour} hours {minute} minutes',
		resendSuccess: 'send success'
	},
	brandListDetail: {
		breadcrumbTitle: 'brand information maintenance',
		breadcrumbAddTitle: 'add brand',
		addTitle: 'add brand information',
		editTitle: 'edit brand information',
		brandName: 'Brand Name',
		brandWebsite: 'brand website',
		emailTopics: 'e-mail subject',
		contact: 'contact',
		sender: 'sender',
		logo: 'Logo',
		emailTemp: 'e-mail template',
		dynamicData: 'dynamic data',
		validTime: 'payment valid time',
		hours: 'hours',
		tips: 'no more than 168 hours',
		editButton: 'Edit',
		addButton: 'Add',
		cancelButton: 'Cancel',
		confirmButton: 'Confirm',
		emailTempTip: 'Click here to start entering email templates...'
	},
	emailPreview: {
		title: 'Brand information maintenance',
		preview: 'Preview'
	},
	payLinkRules: {
		template: 'Please select a template',
		accId: 'Please select your website',
		currency: 'Please choose the currency',
		brandId: 'Please select the Brand Name',
		name: 'Please fill in the name of the booker',
		phone: 'Please fill in the cell phone number',
		email: 'Please fill in E-mail',
		country: 'Please select country/region',
		otherFeeName: 'Please fill in the name of other fees',
		otherFeeAmount: 'Please fill in the amount',
		required: 'This field is required.'
	},
	brandRules: {
		brandName: 'Please fill in the Brand Name',
		website: 'Please fill in the brand website',
		subject: 'Please fill in the email subject',
		contact: 'Please fill in the contact information',
		logo: 'Please upload Logo',
		emailTemplate: 'Please fill in the email template',
		validHours: 'Please fill in the payment validity time',
		validHours168: 'Payment validity cannot exceed 168 hours',
		emailSender: 'Please select sender'
	},
	// 春秋航空定制
	springAirlines: {
		message: {
			title: 'Check in Luggage',
			userInfo: 'User information',
			billingInfo: 'Billing address',
			orderInfo: 'Order detail',
			name: 'Full name',
			phone: 'Mobile',
			email: 'Email',
			country: 'Country/Region',
			city: 'City',
			zipCode: 'Zip code',
			state: 'State',
			street: 'Address',
			goodsName: 'Product name',
			baggageFee: 'baggage check-in fee',
			amount: 'Amount',
			submit: 'Submit and Pay'
		},
		rules: {
			name: 'please enter full name',
			phone: 'please enter phone',
			amount: 'please enter amount'
		},
		goodsName: 'baggage check-in fee'
	},
	// 模版管理
	templateManage: {
		title: 'Template Management',
		sector: 'Industry Sector',
		templateName: 'Template Name',
		addTemplate: 'Add New Template',
		updateTime: 'Last Updated',
		defaultTemplate: 'System',
		deleteTip: 'Are you sure you want to delete this template information?',
		deleteSuccess: 'Deletion Successful',
		message: {
			addSuccess: 'Template added successfully!',
			editSuccess: 'Template updated successfully!'
		}
	},
	templateDetail: {
		editTitle: 'Edit Template',
		addTitle: 'Add New Template',
		detailTitle: 'System Template Details',
		tip: `When sending invoices, the system's fixed fields are in English. Please try to use English for custom field names.`,
		customerData: 'Customer Information',
		productData: 'Product Information',
		addField: 'Add Field',
		options: 'Options',
		editOptions: 'Edit Options',
		addOptions: 'Add Option',
		addOptionsTip: 'Only one option can be selected by your customers',
		editButton: 'Edit',
		addButton: 'Create',
		cancelButton: 'Cancel'
	},
	templateFields: {
		fieldName: 'Field Name',
		labelName: 'Label Name',
		fieldType: 'Type',
		fieldRule: 'Required/Optional',
		fieldRequired: 'Required',
		fieldOptional: 'Optional',
		fieldText: 'Text',
		fieldNumber: 'Number',
		fieldSelect: 'Dropdown',
		fieldDate: 'Date',
		fieldPercent: 'Percent'
	},
	templateRules: {
		sector: 'Please select an industry sector',
		templateName: 'Please enter a template name',
		fieldName: 'Please enter a field name',
		fieldType: 'Please select a field type',
		fieldRule: 'Please select a field validation rule',
		optionsRule: 'Please add custom options',
		optionsValid: 'Please input your added options before saving'
	},
	map: {
		longTerm: 'Long Term',
		shortTerm: 'Short Term',
		firstClass: 'First Class',
		businessClass: 'Business Class',
		premiumEconomy: 'Premium Economy',
		economy: 'Economy',
		small: 'small',
		medium: 'medium',
		large: 'large',
		premium: 'premium',
		suvTruck: 'suv truck',
		van: 'van',
		convertible: 'convertible'
	},
	industryMap: {
		apartmentRent: 'ApartmentRent',
		eCommerce: 'E-commerce',
		carRental: 'CarRental',
		airline: 'Airline',
		tourism: 'Tourism',
		rentalInfo: ' Rental Information',
		productInfo: ' Product Information',
		flightInfo: ' Flight Information',
		serviceInfo: ' Service Information',
		reCharge: ' ReCharge',
		reChargeInfo: ' ReCharge Information',
		hotel: 'Hotel',
		hotelInfo: ' Hotel Information'
	},

	// 支付链优化 - 3
	payLink: {
		orderPreview: 'Order Preview',
		preview: 'Preview',
		saveDraft: 'Save Draft',
		send: 'Submit',
		selectWeb: 'Select Website',
		orderNo: 'Business Order Number',
		theme: 'Subject',
		modeName: 'Mode Name',
		payerInfo: 'Payer Information',
		name: 'Name',
		phone: 'Phone Number',
		remark: 'Remark',
		notThemeTitle: 'You haven\'t created a subject yet',
		notThemeTip: 'Please create a subject in the [Subject Management] feature before creating a payment link',
		notThemeButton: 'Go to Create Subject',
		notModeTitle: 'You haven\'t created a mode yet',
		notModeTip: 'Please create a mode in the [Mode Management] feature before creating a payment link',
		notModeButton: 'Go to Create Mode'
	},
	modeManage: {
		title: 'Mode Settings',
		addMode: 'Add Mode',
		modeName: 'Mode Name',
		isSendEmail: 'Send Email',
		effectiveTime: 'Effective Duration',
		updateTime: 'Update Time',
		deleteTip: 'Are you sure you want to delete the mode information?',
		deleteSuccess: 'Deleted successfully'
	},
	addMode: {
		title: 'Mode Management',
		addMode: 'Add Mode',
		editMode: 'Edit Mode',
		emailInfo: 'Email Information',
		isNeedEmail: 'Email service required ',
		yes: 'Yes',
		no: 'No',
		tip: 'We will send an email to the customer\'s email address provided in the bill when you send the payment link.',
		insert: 'Insert Dynamic Data',
		clientName: 'Client Name',
		orderInfo: 'Order Details',
		checkAmount: 'Bill Amount',
		checkId: 'Bill ID',
		expireTime: 'Expiration Time',
		paymentLink: 'Payment Link',
		emailTitle: 'Email Subject',
		emailContent: 'Email Content',
		sender: 'Sender',
		linkExpire: 'Link Validity',
		oneDay: '24 hours',
		twoDays: '48 hours',
		custom: 'Custom',
		create: 'Create',
		edit: 'Modify',
		previewEmail: 'Preview Email',
		cancel: 'Cancel',
		required: 'This field is required',
		validHours168: 'Payment validity cannot exceed 168 hours',
		hours: 'hours',
		hoursTips: 'Not exceeding 168 hours',
		previewTip: 'Please enter email content first'
	},
	theme: {
		manage: 'Subject Management',
		title: 'Subject Information',
		editTheme: 'Edit Subject',
		copyTheme: 'Copy Subject',
		addTheme: 'Add Subject',
		deleteTheme: 'Delete Subject',
		themeName: 'Subject Name',
		brandName: 'Brand Name',
		brandLogo: 'Brand Logo',
		preview: 'Preview',
		fields: 'Bill Field Information',
		sector: 'Industry Category',
		ifSetDefault: 'Set as default Subject?',
		setDefault: 'Set as Default Subject',
		yes: 'Yes',
		no: 'No',
		create: 'Create',
		edit: 'Modify',
		cancel: 'Cancel',
		// Theme List
		default: 'Default',
		updateOf: 'Updated on',
		deleteTip: 'Are you sure you want to delete?',
		emptyTip: 'No data, please add a subject'
	},
	totalFee: {
		amount: 'Subtotal',
		totalAmount: 'Total'
	},
	paylinkStatus: {
		all: 'All',
		vaild: 'Valid',
		invalid: 'Invalid'
	},
	payStatus: {
		all: 'All',
		unpaid: 'Unpaid',
		successful: 'Successful',
		failed: 'Failed',
		reviewing: 'Reviewing'
	},
	button: {
		cancel: 'Cancel',
		confirm: 'Confirm',
		save: 'Save'
	}
}

export default en
